import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import calendly from 'Scripts/calendly.js';
import whenVisible from 'Utils/whenVisible.js';
import analytics from 'Scripts/analytics.js';

window.removeSeparatorAtEndOfLine = () => {
	let lastElement = false;
	const els = document.querySelectorAll('#hero ul li');

	if (els.length > 0) {
		for (const element of els) {
			if (lastElement && lastElement.offsetTop !== element.offsetTop) {
				lastElement.classList.remove('has-bullet');
			} else if (lastElement) {
				lastElement.classList.add('has-bullet');
			}

			lastElement = element;
		}

		els[els.length - 1].classList.remove('has-bullet');
	}
};

document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.add('is-loaded');
	});

	calendly.setUpCalendly();
	window.removeSeparatorAtEndOfLine();
	analytics.trackTaggedAnchors();

	// Handle mobile navigation
	// Check for click events on the navbar burger icon

	const navbarBurger = document.querySelector('.navbar-burger');
	const navbarMenu = document.querySelector('.navbar-menu');

	navbarBurger?.addEventListener('click', () => {
		// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
		navbarBurger?.classList.toggle('is-active');
		navbarMenu?.classList.toggle('is-active');
	});

	// Apply class when element is visible
	whenVisible();
});
window.addEventListener('resize', window.removeSeparatorAtEndOfLine);
